import { Auth0Client } from "@auth0/auth0-spa-js"

import appConfig from "../../config/app.config"
import { Auth0AuthProvider, httpClient } from "./auth0-auth-provider"

export const auth0 = new Auth0Client({
  domain: appConfig.auth0Domain,
  clientId: appConfig.auth0ClientId,
  cacheLocation: "localstorage",
  authorizationParams: {
    audience: appConfig.auth0Audience,
  },
})

export const authProvider = Auth0AuthProvider(auth0)
export const auth0HttpClient = httpClient(auth0)
